<template>
  <div class="TestKit" ref="TestKit">
    <template v-if="active === 0">
      <div class="form">
        <van-form
          @submit="onSubmit(form)"
          @failed="failed"
          ref="info"
          :show-error="false"
          label-width="150"
          :scroll-to-error="true"
          :input-align="'right'"
        >
          <van-field
            v-model="form.name"
            name="name"
            maxlength="10"
            label="姓名"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />

          <van-field
            v-model="form.idCardNo"
            @change="idCardNoChange(form.idCardNo)"
            name="idCardNo"
            label="身份证号"
            placeholder="请输入身份证号"
            :error-message="idCardNo_error"
            :rules="[
              { required: true, message: '请输入身份证号' },
              {
                pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                message: '身份证号不正确',
              },
            ]"
          />

          <van-field
            name="gender"
            label="性别"
            :rules="[{ required: true, message: '请选择性别' }]"
          >
            <template #input>
              <div class="radio">
                <van-radio-group v-model="form.gender" direction="horizontal">
                  <van-radio name="0">女</van-radio>
                  <van-radio name="1">男</van-radio>
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <van-field
            v-model="form.age"
            name="age"
            type="digit"
            label="年龄"
            placeholder="请输入年龄"
            :rules="[{ required: true, message: '请输入年龄' }]"
          />

          <van-field
            v-model="form.height"
            name="height"
            type="digit"
            label="身高"
            placeholder="请输入身高"
            :rules="[{ required: true, message: '请输入身高' }]"
          >
            <template #right-icon>
              <span class="Company">厘米</span>
            </template>
          </van-field>

          <van-field
            v-model="form.weight"
            name="weight"
            type="number"
            label="体重"
            placeholder="请输入体重"
            :rules="[{ required: true, message: '请输入体重' }]"
          >
            <template #right-icon>
              <span class="Company">公斤</span>
            </template>
          </van-field>

          <van-field
            v-model="form.systolicPressure"
            v-if="form.sort == 'taxi'"
            name="systolicPressure"
            type="digit"
            label="收缩压（选填）"
            placeholder="请输入收缩压"
          >
            <!--            :rules="[{ required: true, message: '请输入收缩压' }]"-->
            <template #right-icon>
              <span class="Company">mmHg</span>
            </template>
          </van-field>

          <van-field
            v-model="form.diastolicPressure"
            v-if="form.sort == 'taxi'"
            name="diastolicPressure"
            type="digit"
            label="舒张压（选填）"
            placeholder="请输入舒张压"
          >
            <!--            :rules="[{ required: true, message: '请输入舒张压' }]"-->
            <template #right-icon>
              <span class="Company">mmHg</span>
            </template>
          </van-field>

          <van-field
            v-if="form.sort == 'taxi'"
            readonly
            clickable
            name="birthday"
            :value="form.birthday"
            label="出生日期"
            placeholder="点击选择出生日期"
            @click="showBirthday = true"
            :rules="[{ required: true, message: '请选择出生日期' }]"
          />
          <van-popup v-model="showBirthday" position="bottom">
            <van-datetime-picker
              v-model="form.birthdays"
              type="date"
              title="选择年月日"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirmBirthday"
              @cancel="showBirthday = false"
            />
          </van-popup>

          <!--          <van-field-->
          <!--            readonly-->
          <!--            clickable-->
          <!--            name="samplingTime"-->
          <!--            :value="form.samplingTime"-->
          <!--            label="填表日期"-->
          <!--            placeholder="点击选择填表日期"-->
          <!--            @click="showSamplingTime = true"-->
          <!--            :rules="[{ required: true, message: '请选择填表日期' }]"-->
          <!--          />-->
          <!--          <van-popup v-model="showSamplingTime" position="bottom">-->
          <!--            <van-datetime-picker-->
          <!--              v-model="form.samplingTimes"-->
          <!--              type="date1"-->
          <!--              title="选择年月日"-->
          <!--              :min-date="minDate"-->
          <!--              :max-date="maxDate"-->
          <!--              @confirm="onConfirmSamplingTime"-->
          <!--              @cancel="showSamplingTime = false"-->
          <!--            />-->
          <!--          </van-popup>-->

          <van-field
            class="TestKitRadio"
            v-if="form.sort == 'taxi'"
            name="nation"
            label="民族"
            placeholder="请选择民族"
            :rules="[{ required: true, message: '请选择民族' }]"
          >
            <template #input>
              <div class="TestKitRadioGroup">
                <van-radio-group v-model="form.nation" direction="horizontal">
                  <van-radio name="0">汉</van-radio>
                  <van-radio name="1">回</van-radio>
                  <van-radio name="2">满</van-radio>
                  <van-radio name="3">其他</van-radio>
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <van-field
            class="TestKitRadio"
            name="educationLevel"
            label="教育程度"
            :rules="[{ required: true, message: '请选择教育程度' }]"
          >
            <template #input>
              <div class="TestKitRadioGroup">
                <van-radio-group
                  v-model="form.educationLevel"
                  direction="horizontal"
                >
                  <van-radio
                    v-for="item in $store.state.educationLevelList"
                    :key="item.dictKey"
                    :name="item.dictKey"
                    >{{ item.dictValue }}</van-radio
                  >
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <van-field
            class="TestKitRadio"
            name="maritalStatus"
            label="婚姻状况"
            :rules="[{ required: true, message: '请选择婚姻状况' }]"
          >
            <template #input>
              <div class="TestKitRadioGroup">
                <van-radio-group
                  v-model="form.maritalStatus"
                  direction="horizontal"
                >
                  <van-radio
                    v-for="item in $store.state.maritalStatusList"
                    :key="item.dictKey"
                    :name="item.dictKey"
                    >{{ item.dictValue }}</van-radio
                  >
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <van-field
            class="TestKitRadio"
            v-if="
              form.sort == 'normal' || form.sort == 'shi' || form.sort == 'fit'
            "
            name="occupation"
            label="职业"
            :rules="[{ required: true, message: '请选择职业' }]"
          >
            <template #input>
              <div class="TestKitRadioGroup">
                <van-radio-group
                  v-model="form.occupation"
                  direction="horizontal"
                >
                  <van-radio
                    v-for="item in $store.state.occupation"
                    :key="item.dictKey"
                    :name="item.dictKey"
                    >{{ item.dictValue }}</van-radio
                  >
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <van-field
            class="TestKitRadio"
            name="medicalInsuranceType"
            label="医保类型"
            :rules="[{ required: true, message: '请选择医保类型' }]"
          >
            <template #input>
              <div class="TestKitRadioGroup">
                <van-checkbox-group
                  v-model="form.medicalInsuranceType"
                  direction="horizontal"
                >
                  <van-checkbox
                    v-for="item in $store.state.medicalInsuranceTypeList"
                    :key="item.dictKey"
                    shape="square"
                    :name="item.dictKey"
                    >{{ item.dictValue }}</van-checkbox
                  >
                </van-checkbox-group>
                <!--                <van-radio-group v-model="form.medicalInsuranceType" direction="horizontal">-->
                <!--                  <van-radio name="0">城镇职工</van-radio>-->
                <!--                  <van-radio name="1">城镇居民</van-radio>-->
                <!--                  <van-radio name="2">公费医疗</van-radio>-->
                <!--                  <van-radio name="3">商业保险</van-radio>-->
                <!--                  <van-radio name="4">自费</van-radio>-->
                <!--                  <van-radio name="5">其他</van-radio>-->
                <!--                </van-radio-group>-->
              </div>
            </template>
          </van-field>

          <van-field
            v-if="form.sort == 'taxi'"
            readonly
            clickable
            name="residentialAddress"
            :value="
              form.residentialAddress
                ? columns.filter((item) => {
                    return item.dictKey == form.residentialAddress
                  })[0].dictValue
                : null
            "
            label="地址"
            placeholder="请输入地址"
            @click="showPicker = true"
            :rules="[{ required: true, message: '请输入地址' }]"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              value-key="dictValue"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>

          <van-field
            v-if="
              form.sort == 'normal' || form.sort == 'shi' || form.sort == 'fit'
            "
            v-model="form.detailAddress"
            name="name"
            label="住址"
            placeholder="请输入住址"
            :rules="[{ required: true, message: '请输入住址' }]"
          />

          <van-field
            v-model="form.phoneNoOne"
            name="phoneNoOne"
            label="受检人手机号"
            placeholder="用于结果查询，请录入"
            :error-message="phoneNoOne_error"
            :rules="[
              { required: true, message: '用于结果查询，请录入' },
              {
                pattern:
                  /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/,
                message: '受检人手机号不正确',
              },
            ]"
          />

          <van-field
            v-model="form.phoneNoTwo"
            name="phoneNoTwo"
            label="其他联系方式（选填）"
            placeholder="请输入其他联系方式"
            :error-message="phoneNoTwo_error"
          />

          <!--        <van-field-->
          <!--          v-model="form.barCode"-->
          <!--          name="barCode"-->
          <!--          label="条形码"-->
          <!--          :disabled="false"-->
          <!--          placeholder="请扫描条形码"-->
          <!--          :rules="[{ required: true, message: '请扫描条形码' }]"-->
          <!--        >-->
          <!--          <template #right-icon>-->
          <!--            <van-icon @click="BarCode" name="scan" />-->
          <!--          </template>-->
          <!--        </van-field>-->

          <van-field
            class="no_line"
            v-model="form.reagentNo"
            name="qrCode"
            label="试剂盒编号"
            :disabled="false"
            placeholder="请扫描试剂盒编号"
            :rules="[{ required: true, message: '请扫描试剂盒编号' }]"
          >
            <template #right-icon>
              <van-icon @click="QRCode" name="scan" />
            </template>
          </van-field>

          <div class="footer_button">
            <van-button round block type="info" native-type="onSubmit"
              >下一步</van-button
            >
            <!--            :loading="loads" :disabled="loads"-->
          </div>
        </van-form>
      </div>
    </template>

    <template v-else>
      <div class="form TestKitForm">
        <van-form
          @submit="onSubmitTest(TestKitList)"
          @failed="failedTest"
          ref="Test"
          :show-error="false"
          label-width="100%"
          :scroll-to-error="true"
          :input-align="'left'"
        >
          <template>
            <div v-for="(item, index) in TestKitList" :key="index" class="mar">
              <div class="TestKitList">
                <div class="title">
                  {{ item.category }}
                </div>
                <template>
                  <div
                    v-for="(items, indexs) in item.questionList"
                    :key="indexs"
                  >
                    <van-field
                      v-if="items.isShow == '1' && items.type == '0'"
                      class="TestKitRadio"
                      name="medicalInsuranceType"
                      :label="items.title"
                      :rules="[{ required: true, message: '此项为必填项' }]"
                    >
                      <template #input>
                        <div class="TestKitRadioGroup">
                          <van-radio-group
                            v-model="items.value"
                            direction="horizontal"
                            @change="questionChange($event, items)"
                          >
                            <van-radio
                              v-for="itemss in items.answerList"
                              :key="itemss.answerId"
                              :name="itemss.answerId"
                              >{{ itemss.answerContent }}</van-radio
                            >
                          </van-radio-group>
                        </div>
                      </template>
                    </van-field>
                    <van-field
                      v-if="items.isShow == '1' && items.type == '2'"
                      class="TestKitInput"
                      :label="items.title"
                    >
                      <template #input>
                        <div
                          class="inputs"
                          v-for="(
                            itemss, indexss
                          ) in items.childrenQuestionVOList"
                          :key="indexss"
                        >
                          <van-field
                            v-if="itemss.type == '2'"
                            v-model="itemss.value"
                            :label="itemss.title"
                            :rules="[
                              { required: true, message: '此项为必填项' },
                            ]"
                          />
                        </div>
                      </template>
                    </van-field>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <div class="footer_button">
            <Agreement
              :isAgree.sync="isAgree"
              :agreementType="agreementType"
              :agreementIdList.sync="form.agreementIdList"
            ></Agreement>
            <!--            :disabled="loads || isAgree.length == 0"-->
            <van-button
              round
              block
              type="info"
              :loading="loads"
              native-type="onSubmitTest"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </template>
  </div>
</template>

<script>
import {
  Field,
  Button,
  Form,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Icon,
  Checkbox,
  CheckboxGroup,
  Picker,
  Toast,
} from 'vant' // 单元格
import wx from 'weixin-js-sdk'
import idCardNo from '../../utils/idCardNo'
import Agreement from '@/components/Agreement'

export default {
  name: 'TestKitInfo',
  data() {
    return {
      active: 0,
      agreementType: 'hmPlan',
      form: {
        name: null, // 姓名
        idCardNo: null, // 身份证号
        age: null, // 年龄
        gender: null, // 性别
        height: null, // 身高
        weight: null, // 体重
        diastolicPressure: null, // 舒张压
        systolicPressure: null, // 收缩压
        nation: null, // 民族
        // 出生日期
        birthday: null,
        birthdays: new Date(),
        // 教育成都
        educationLevel: null,
        maritalStatus: null, // 婚姻状态
        medicalInsuranceType: [], // 医保类型
        residentialAddress: null, // 地址
        phoneNoOne: null, // 受检人手机号
        phoneNoTwo: null, // 其他联系方式
        reagentNo: null, // 试剂盒编号
        agreementIdList: [], // 协议id
        occupation: null, // 职业
        detailAddress: null, // 住址
        sort: this.$route.query.state, // 问卷种类
        inviter: this.$route.query.inviter, // 发放人
      },
      // 错误提示
      idCardNo_error: null,
      phoneNoOne_error: null,
      phoneNoTwo_error: null,
      // button loading
      loads: false,
      // 出身日期
      showBirthday: null,
      // 填表日期
      showSamplingTime: null,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(),
      // 问卷list
      TestKitList: [],
      showPicker: false,
      columns: [],
      isAgree: [],
      verifyApi: {
        normal: 'reagent/verifyNormal',
        shi: 'reagent/verifyNormal',
        fit: 'reagent/verifyFit',
      },
      submitApi: {
        normal: 'reagent/normal',
        shi: 'reagent/normal',
        fit: 'reagent/fit',
      },
    }
  },
  watch: {},
  created() {
    // document.title = "问卷调查";
    document.title = '肠道风险自测'
    let state = this.$route.query.state
    state == 'shi' ? (state = 'normal') : null
    this.get_question(state)
    this.address()
    this.$store.dispatch('setOccupation', 'normal')
    this.$store.dispatch('setEducationLevelList', 'normal')
    this.$store.dispatch('setMaritalStatusList', 'normal')
    this.$store.dispatch('setMedicalInsuranceTypeList', 'normal')
  },
  mounted() {},
  methods: {
    address() {
      this.$get('base/reagent/address').then((res) => {
        this.columns = res.data
      })
    },
    onConfirm(e) {
      this.form.residentialAddress = e.dictKey
      this.showPicker = false
    },
    questionChange(e, y) {
      if (e == y.logicAnswerId) {
        y.showId.forEach((item) => {
          this.TestKitList.forEach((items) => {
            items.questionList.forEach((itemss) => {
              if (itemss.questionId == item) {
                itemss.isShow = '1'
              }
            })
          })
        })
      } else {
        y.showId.forEach((item) => {
          this.TestKitList.forEach((items) => {
            items.questionList.forEach((itemss) => {
              if (itemss.questionId == item) {
                itemss.isShow = '0'
                console.log(itemss)
                if (itemss.type == '2') {
                  itemss.childrenQuestionVOList.forEach((itemsss) => {
                    itemsss.value = null
                  })
                } else if (itemss.type == '0') {
                  itemss.value = null
                }
              }
            })
          })
        })
      }
    },
    failedTest() {
      Toast.fail('您有未填写的项目')
    },
    onSubmitTest(y) {
      // this.loads= true;

      if (this.form.agreementIdList.length === 0) {
        this.$toast.error('请阅读并同意协议')
        return
      }

      let arr = []

      y.forEach((item) => {
        item.questionList.forEach((items) => {
          if (items.isShow === '1') {
            switch (items.type) {
              case 0: {
                let obj = {}
                obj['questionId'] = items.questionId
                obj['answerId'] = items.value
                obj['answerStr'] = null
                arr.push(obj)
                break
              }
              case 2: {
                items.childrenQuestionVOList.forEach((itemss) => {
                  let obj = {}
                  obj['questionId'] = itemss.questionId
                  obj['answerId'] = null
                  obj['answerStr'] = itemss.value
                  arr.push(obj)
                })
                break
              }
            }
          }
        })
      })

      let obj = {}
      obj['info'] = this.form
      obj['questionAndAnswer'] = arr
      this.$post(this.submitApi[this.form.sort] || 'reagent', obj).then(
        (res) => {
          console.log(res)

          if (res) {
            let obj = {}
            obj['name'] = this.form.name
            obj['phoneNoOne'] = this.form.phoneNoOne
            obj['idCardNo'] = this.form.idCardNo
            obj['reagentNo'] = this.form.reagentNo

            this.$router.replace({
              path: '/TestKitInfoResult',
              query: {
                info: obj,
              },
            })
          }

          this.loads = false
        }
      )
      // if (
      //   this.$route.query.state == 'normal' ||
      //   this.$route.query.state == 'shi'
      // ) {
      //   this.$post('reagent/normal', obj).then((res) => {
      //     console.log(res)

      //     if (res) {
      //       let obj = {}
      //       obj['name'] = this.form.name
      //       obj['phoneNoOne'] = this.form.phoneNoOne
      //       obj['idCardNo'] = this.form.idCardNo
      //       obj['reagentNo'] = this.form.reagentNo

      //       this.$router.replace({
      //         path: '/TestKitInfoResult',
      //         query: {
      //           info: obj,
      //         },
      //       })
      //     }

      //     this.loads = false
      //   })
      // } else {
      //   this.$post('reagent', obj).then((res) => {
      //     console.log(res)

      //     if (res) {
      //       let obj = {}
      //       obj['name'] = this.form.name
      //       obj['phoneNoOne'] = this.form.phoneNoOne
      //       obj['idCardNo'] = this.form.idCardNo
      //       obj['reagentNo'] = this.form.reagentNo

      //       this.$router.replace({
      //         path: '/TestKitInfoResult',
      //         query: {
      //           info: obj,
      //         },
      //       })
      //     }

      //     this.loads = false
      //   })
      // }
    },
    // 获取问卷数据
    get_question(y) {
      let obj = {}
      obj['activityType'] = y
      this.$get('reagent/question', obj).then((res) => {
        console.log(res)

        this.TestKitList = res.data
      })
    },
    // 身份证生成年龄和性别
    idCardNoChange(e) {
      this.$refs.info
        .validate('idCardNo')
        .then((res) => {
          console.log(res)
          // if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(e)) {
          if (idCardNo.idCardNo.checkIdCardNo(e)) {
            this.form.birthday = idCardNo.idCardNo.getIdCardNoInfo(e).dob
            this.form.birthdays = new Date(
              idCardNo.idCardNo.getIdCardNoInfo(e).dob
            )

            this.form.age = this.GetAge(e)
            if (e[e.length - 2] % 2 == 0) {
              this.form.gender = '0'
            } else {
              this.form.gender = '1'
            }
            this.idCardNo_error = null
          } else {
            this.idCardNo_error = '身份证号不正确'
            this.form.gender = null
            this.form.age = null
            this.form.birthday = null
          }
        })
        .catch((err) => {
          console.log(err)
          // alert(222)
        })
    },
    failed() {
      Toast.fail('您有未填写的项目')
    },
    onSubmit() {
      // /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.form.idCardNo)
      if (idCardNo.idCardNo.checkIdCardNo(this.form.idCardNo)) {
        this.idCardNo_error = null
        if (
          /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(
            this.form.phoneNoOne
          )
        ) {
          this.phoneNoOne_error = null

          this.$post(
            this.verifyApi[this.form.sort] || 'reagent/verify',
            this.form
          ).then((res) => {
            console.log(res)

            if (res) {
              this.active = 1

              // document.title= "肠道风险自测";

              this.$nextTick(() => {
                this.$refs.TestKit.scroll(0, 0)
                // window.scrollTo(0,0);
              })
            } else {
              Toast.fail(res.data.message)
            }
          })
          // if (this.form.sort == 'normal' || this.form.sort == 'shi') {
          //   this.$post('reagent/verifyNormal', this.form).then((res) => {
          //     console.log(res)

          //     if (res) {
          //       this.active = 1

          //       // document.title= "肠道风险自测";

          //       this.$nextTick(() => {
          //         this.$refs.TestKit.scroll(0, 0)
          //         // window.scrollTo(0,0);
          //       })
          //     } else {
          //       Toast.fail(res.data.message)
          //     }
          //   })
          // } else {
          //   this.$post('reagent/verify', this.form).then((res) => {
          //     console.log(res)

          //     if (res) {
          //       this.active = 1

          //       // document.title= "肠道风险自测";

          //       this.$nextTick(() => {
          //         this.$refs.TestKit.scroll(0, 0)
          //         // window.scrollTo(0,0);
          //       })
          //     } else {
          //       Toast.fail(res.data.message)
          //     }
          //   })
          // }
        } else {
          this.phoneNoOne_error = '受检人手机号不正确'
        }
      } else {
        this.idCardNo_error = '身份证号不正确'
      }
    },
    BarCode() {
      let that = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          setTimeout(() => {
            let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            let index = result.indexOf(',') + 1
            if (index) {
              that.form.barCode = result.substring(index)
            } else {
              that.form.qrCode = result
            }
          }, 1000)
        },
      })
    },
    QRCode() {
      let that = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          setTimeout(() => {
            let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            let index = result.indexOf(',') + 1
            if (index) {
              // 条形码
              // that.form.barCode= result.substring(index);
              that.form.reagentNo = result.substring(index)
            } else {
              // 二维码
              that.form.reagentNo = result
            }
          }, 1000)
        },
      })
    },
    onConfirmBirthday(e) {
      console.log(e)
      this.form.birthday = this.formatDate(e)
      this.showBirthday = false
    },
    onConfirmSamplingTime(e) {
      console.log(e)
      this.form.samplingTime = this.formatDate(e)
      this.showSamplingTime = false
    },
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [Toast.name]: Toast,
    Agreement,
  },
}
</script>

<style lang="scss" scoped>
@import '../../style/TestKit/TestKitInfo';
</style>
